export default __webpack_public_path__ + "static/media/pencil-outline.dddbe510.svg";